import React from "react"

import { Slider } from "@coval/ui"

import { cn } from "@/utils/cn"

import { DEFAULT_SIMILARITY_THRESHOLD } from "../utils/groupBySimilarity"

interface SimilarityThresholdSliderProps {
  value: number
  onChange: (value: number) => void
  className?: string
}

/**
 * Slider for tuning the Jaccard threshold used when reordering rows by
 * explanation similarity. Bounds and step are fixed to match product spec.
 */
export const SimilarityThresholdSlider: React.FC<
  SimilarityThresholdSliderProps
> = ({ value, onChange, className }) => (
  <div
    className={cn(
      "flex items-center gap-2 text-xs text-coval-text-muted",
      className,
    )}
  >
    <span className="whitespace-nowrap">Group similarity</span>
    <Slider
      aria-label="Group rows by explanation similarity threshold"
      min={0.3}
      max={0.8}
      step={0.05}
      value={[value]}
      onValueChange={(vals) =>
        onChange(vals[0] ?? DEFAULT_SIMILARITY_THRESHOLD)
      }
      className="w-32"
    />
    <span className="tabular-nums w-8 text-right">{value.toFixed(2)}</span>
  </div>
)
